import { Brick, registerBrick } from 'olympe';

export default class DragonResultWrapper extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<!Object>} result
     * @param {number} count
     * @param {function()} forwardEvent
     * @param {function(!ErrorFlow)} setErrorFlow
     * @param {function(!Object)} setResult
     */
    update(_$, [result, count], [forwardEvent, _setErrorFlow, setResult]) {
        // Apply post-processing on the result
        const data = result.map(record => {
            // Retrieve entries and clean them:
            //  - trim string values
            const entries = Object.entries(record)
                .map(([key, value]) => [key, typeof value === 'string' ? value.trim() : value]);

            // Special case: record with 1 entry should only have the value
            if(entries.length === 1) {
                return entries[0][1];
            }

            // Special case: record with 2 entries should be a "id+description" object
            else if(entries.length === 2) {
                return {
                    id: entries[0][1],
                    description: entries[1][1]
                };
            }

            // Default case: return the post-processed entries as-is
            else {
                return Object.fromEntries(entries);
            }
        });

        // Special case: record with 1 entry should be sorted
        if(data.length > 0 && typeof data[0] !== 'object') {
            data.sort();
        }

        // Wrapped result
        const object = {
            total: count,
            count: data.length,
            data: data
        };

        // Done
        setResult(object);
        forwardEvent();
    }
}

registerBrick('0186551c804abdee8592', DragonResultWrapper);
